import { useTracking } from '@change/core/react/tracking';
import { openWindow } from '@change/core/window';

import { usePetitionDetailsPageData } from 'src/app/pages/petitionGamma/details/pageContext';
import { useCurrentUserIdAsync } from 'src/app/shared/hooks/session';
import { isLoaded } from 'src/app/shared/utils/async';
import { craftSupporterEmail } from 'src/app/shared/utils/decisionMaker';

type Result = ModelHookResult<
	{ emailHref: string },
	{
		handleEmailDmClick: () => void;
	}
>;

export function useEmailDm({ dmEmail, dmName }: { dmEmail: string; dmName: string }): Result {
	const currentUserState = useCurrentUserIdAsync();
	const viewerId = isLoaded(currentUserState) ? currentUserState.value : undefined;

	const track = useTracking();

	const {
		data: {
			petition: {
				slug,
				ask,
				signatureState: {
					signatureCount: { displayedLocalized: signatureCount },
				},
			},
			emailDm,
		},
	} = usePetitionDetailsPageData();

	const emailHref = craftSupporterEmail({
		dmEmail,
		dmName,
		ask,
		slug,
		signatureCount,
		emailDm,
	});

	const handleEmailDmClick = () => {
		void track('petition_page_email_dm_click', {
			user_id: viewerId,
		});
		if (emailHref) openWindow(emailHref);
	};

	return {
		data: { emailHref },
		actions: {
			handleEmailDmClick,
		},
	};
}
